<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dhpBBF/tc-custom/9780253023872.jpg?1737195127425" alt="This image is the cover for the book Moses Mendelssohn's Living Script"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moses Mendelssohn's Living Script
      </h1>
      <p class="bookDescription body article font2">
        <p>Moses Mendelssohn (1729–1786) is often described as the founder of modern Jewish thought and as a leading philosopher of the late Enlightenment. One of Mendelssohn's main concerns was how to conceive of the relationship between Judaism, philosophy, and the civic life of a modern state. Elias Sacks explores Mendelssohn's landmark account of Jewish practice—Judaism's "living script," to use his famous phrase—to present a broader reading of Mendelssohn's writings and extend inquiry into conversations about modernity and religion. By studying Mendelssohn's thought in these dimensions, Sacks suggests that he shows a deep concern with history. Sacks affords a view of a foundational moment in Jewish modernity and forwards new ways of thinking about ritual practice, the development of traditions, and the role of religion in society.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elias Sacks
      </h2>
      
      <p class="authorDescription body article"><P>Elias Sacks is Assistant Professor of Religious Studies and Jewish Studies at the University of Colorado Boulder.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97d4c3d0